// @ts-nocheck
import { Game } from "./game-base";
import { Sound } from "../audio";
import { isAdminAccount } from "../data";
import { recordAlphaSplashView } from "../util";

const ALPHA_SCHEDULED_CHEAT = "2112";

function fmtAlphaCountdown(ms) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  if (d > 0) return `${d}d ${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

function alphaStartMs(cfg) {
  const iso = cfg?.startAt;
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d.getTime();
}

function alphaEndMs(cfg) {
  const iso = cfg?.endAt;
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d.getTime();
}

Game.prototype.isAlphaAdmin = function () {
  return isAdminAccount(this.account);
};

Game.prototype.shouldShowAlphaScheduledSplash = function () {
  if (this.isAlphaAdmin()) return false;
  if (this._alphaScheduledSplashDismissed) return false;
  return (this.alphaConfig?.phase || "active") === "scheduled";
};

Game.prototype.dismissAlphaScheduledSplash = function () {
  this._alphaScheduledSplashDismissed = true;
  this.syncAlphaScheduledSplash(false);
  this.show("menu");
};

Game.prototype.tryAlphaScheduledCheat = function (e) {
  if ((this.alphaConfig?.phase || "active") !== "scheduled") return false;
  if (this.keyTargetIsTextField?.(e.target) || this._rebind) return false;
  const digit = e.key;
  if (!/^[0-9]$/.test(digit)) {
    this._alphaCheatSeq = "";
    return false;
  }
  const seq = (this._alphaCheatSeq || "") + digit;
  if (ALPHA_SCHEDULED_CHEAT.startsWith(seq)) {
    this._alphaCheatSeq = seq;
    if (seq === ALPHA_SCHEDULED_CHEAT) {
      this._alphaCheatSeq = "";
      Sound.ui();
      this.dismissAlphaScheduledSplash();
      return true;
    }
    return true;
  }
  this._alphaCheatSeq = "";
  return false;
};

Game.prototype.showAlphaScheduledSplash = function () {
  if (this.isAlphaAdmin() || this._alphaScheduledSplashDismissed) return;
  this.stopLearnPreviews?.();
  window.SpellPreview?.hide?.();
  this.hide("learnPanel");
  this.hide("spellbook");
  this.hide("menu");
  this.state = "menu";
  this.syncAlphaScheduledSplash(true);
  this.syncPreAlphaNotice();
};

Game.prototype.openAlphaScheduledLearn = function () {
  Sound.ui();
  this.syncAlphaScheduledSplash(false);
  this.showLearn();
};

Game.prototype.openAlphaScheduledSpellbook = function () {
  Sound.ui();
  this.syncAlphaScheduledSplash(false);
  this.showSpellbook("alpha-scheduled");
};

Game.prototype.tickAlphaPhaseWatch = function () {
  const cfg = this.alphaConfig;
  const phase = cfg?.phase || "active";
  if (phase === "ended" || this._alphaPhaseReloading) return;
  const now = Date.now();
  const startMs = alphaStartMs(cfg);
  const endMs = alphaEndMs(cfg);
  const startPassed = phase === "scheduled" && startMs != null && now >= startMs;
  const endPassed = endMs != null && now >= endMs;
  if (!startPassed && !endPassed) return;
  this._alphaPhaseReloading = true;
  void this.loadAlphaConfig().finally(() => {
    this._alphaPhaseReloading = false;
  });
};

Game.prototype.isAlphaPlayOpen = function () {
  // Scheduled gate only — after pre-alpha ends, play stays open.
  if (this.isAlphaAdmin()) return true;
  return (this.alphaConfig?.phase || "active") !== "scheduled";
};

Game.prototype.rejectIfAlphaClosed = function () {
  if (this.isAlphaPlayOpen()) return false;
  if (this.alphaConfig?.phase === "scheduled") {
    this.showToast("Pre-Alpha has not started yet.");
    this.syncAlphaScheduledSplash(true);
    this.syncPreAlphaNotice();
    return true;
  }
  return false;
};

Game.prototype.updateAlphaScheduledCountdown = function () {
  if (!this._alphaScheduledShown) return;
  const wrap = document.getElementById("alphaScheduledCountdown");
  const digits = document.getElementById("alphaScheduledCountdownDigits");
  const label = wrap?.querySelector(".alpha-scheduled-countdown-label");
  const startMs = alphaStartMs(this.alphaConfig);
  if (!wrap || !digits || !startMs) return;
  const left = startMs - Date.now();
  const open = left <= 0;
  wrap.classList.toggle("is-open", open);
  if (label) label.textContent = open ? "Pre-Alpha is open" : "Starts in";
  digits.textContent = open ? "Enter the arena" : fmtAlphaCountdown(left);
  if (!open) {
    const secs = Math.ceil(left / 1000);
    if (secs >= 1 && secs <= 3) this.alphaScheduledCountdownBeep(secs);
    else if (secs > 3) this._alphaScheduledCountN = 0;
  } else {
    this._alphaScheduledCountN = 0;
  }
  if (open && this.alphaConfig?.phase === "scheduled" && !this._alphaPhaseReloading) {
    this._alphaPhaseReloading = true;
    void this.loadAlphaConfig().finally(() => {
      this._alphaPhaseReloading = false;
    });
  }
};

Game.prototype.alphaScheduledCountdownBeep = function (n) {
  if (n === this._alphaScheduledCountN) return;
  this._alphaScheduledCountN = n;
  Sound.countdown(n);
};

Game.prototype.syncAlphaScheduledSplash = function (show) {
  const el = document.getElementById("alphaScheduledSplash");
  if (!el) return;
  const visible = !!show;
  if (visible === this._alphaScheduledShown) return;
  this._alphaScheduledShown = visible;
  el.classList.toggle("hidden", !visible);
  if (visible) {
    if (!this._alphaSplashRecorded) {
      this._alphaSplashRecorded = true;
      recordAlphaSplashView();
    }
    this._alphaPhaseReloading = false;
    this._alphaScheduledCountN = 0;
    this.updateAlphaScheduledCountdown();
  }
};

Game.prototype.loadAlphaConfig = async function () {
  try {
    const res = await fetch("/api/alpha", { cache: "no-store" });
    if (!res.ok) throw new Error("alpha config unavailable");
    this.alphaConfig = await res.json();
  } catch {
    this.alphaConfig = { phase: "active", totals: {}, global: {} };
  }
  if ((this.alphaConfig?.phase || "active") !== "scheduled") {
    this._alphaScheduledSplashDismissed = false;
    this._alphaCheatSeq = "";
  }
  if (this._alphaScheduledShown) this.updateAlphaScheduledCountdown();
  this.syncPreAlphaNotice();
};
